import { useEffect, useRef, useState } from "react";

/**
 * Anima um número de `from` até `to` em `duration` ms com easing ease-out.
 * Começa a contar quando o elemento entra no viewport.
 */
export default function CountUp({ to, from = 0, duration = 1400, formatter }) {
  const [value, setValue] = useState(from);
  const nodeRef = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const el = nodeRef.current;
    if (!el) return;
    const run = () => {
      if (startedRef.current) return;
      startedRef.current = true;
      const start = performance.now();
      const animate = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        setValue(Math.round(from + (to - from) * eased));
        if (t < 1) requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    };

    if (!("IntersectionObserver" in window)) {
      run();
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) run();
        });
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [to, from, duration]);

  const formatted = formatter ? formatter(value) : value.toLocaleString("pt-BR");
  return <span ref={nodeRef}>{formatted}</span>;
}
